import { CustomerRole, HomepageContext } from '@amzn/brand-context-service-type-script-client';

export interface VisibilityFunctions {
  customerHasPzAccess: () => boolean,
  customerIs: (showFor: CustomerRole[]) => boolean,
}

export const getVisibilityFunctions = (context: HomepageContext): VisibilityFunctions => ({
  customerHasPzAccess: () => customerHasPzAccess(context),
  customerIs: (roleSet) => context.customerRoles.some((role) => roleSet.includes(role)),
});

export const customerHasPzAccess = (context: HomepageContext) => {
  const { customerRoles, projectZeroInfo: { brandCriteriaMet } } = context;

  const isRightsOwner = customerRoles.includes('RIGHTS_OWNER');
  return isRightsOwner && brandCriteriaMet;
};

export const customerIsPzEligible = (context: HomepageContext) => {
  const { projectZeroInfo: { brandStatusTotals } } = context;

  return brandStatusTotals.ELIGIBLE > 0;
};

export const customerIsPzEnrolled = (context: HomepageContext) => {
  const { projectZeroInfo: { customerCompletedTraining, customerAccessRevoked, brandStatusTotals } } = context;

  return brandStatusTotals.ENROLLED > 0 && customerCompletedTraining && !customerAccessRevoked;
};


export const always = () => true;
